<template>
  <div class="tabs-nav">
    <div class="tabs-nav__container">
      <div class="tabs-nav__tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          @click="handleTabClick(tab.id)"
          class="tabs-nav__tab"
          :class="{ 'tabs-nav__tab--active': activeTab === tab.id }"
        >
          {{ tab.label }}
        </button>
      </div>

      <div class="tabs-nav__actions">
        <slot name="action-button"></slot>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  activeTab: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["tab-change"]);

const handleTabClick = (tabId) => {
  if (tabId !== props.activeTab) {
    emit("tab-change", tabId);
  }
};
</script>

<style lang="scss" scoped>
.tabs-nav {
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
  
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    gap: 16px;
    
    @media only screen and (max-width: 800px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  
  &__tabs {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #F1F5F9;
    padding: 4px;
    border-radius: 10px;
  }
  
  &__tab {
    padding: 10px 20px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #64748B;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    
    &:hover:not(.tabs-nav__tab--active) {
      color: #0F172A;
    }
    
    &--active {
      background: #ffffff;
      color: #0F172A;
      box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
    }
  }
  
  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
</style>